import API_URLS from "@/constants/apiUrls";
import { HTTP_METHODS } from "@/constants/httpMethods";
import { request } from "@/lib/api";
import { jsonToQuery } from "@/utils/queryHelper";

/**
 * Ferry Popular Service
 * Ana sayfa feribot API'leri için servis
 */
export const ferryPopularService = {
  /**
   * Popüler destinasyonları getir
   * @param {Object} payload - API payload
   * @param {Object} headers - HTTP headers
   * @param {boolean} hasErrorHandler - Hata yönetimi aktif mi
   * @returns {Promise} API response
   *
   * Payload Example:
   * {}
   */
  getPopularDomesticFerries: (
    query = {},
    headers = {},
    hasErrorHandler = false,
  ) =>
    request({
      method: HTTP_METHODS.GET,
      url: `${API_URLS.ferry.popular.getPopularDomesticFerries}?${jsonToQuery(query)}`,
      headers,
      hasErrorHandler,
    }),

  getPopularGreeceIslandsData: (
    query = {},
    headers = {},
    hasErrorHandler = false,
  ) =>
    request({
      method: HTTP_METHODS.GET,
      url: `${API_URLS.ferry.popular.getPopularGreeceIslands}?${jsonToQuery(query)}`,
      headers,
      hasErrorHandler,
    }),

  getPopularCyprusData: (query = {}, headers = {}, hasErrorHandler = false) =>
    request({
      method: HTTP_METHODS.GET,
      url: `${API_URLS.ferry.popular.getPopularCyprus}?${jsonToQuery(query)}`,
      headers,
      hasErrorHandler,
    }),

  getPopularInternationalData: (
    query = {},
    headers = {},
    hasErrorHandler = false,
  ) =>
    request({
      method: HTTP_METHODS.GET,
      url: `${API_URLS.ferry.popular.getPopularInternational}?${jsonToQuery(query)}`,
      headers,
      hasErrorHandler,
    }),
  getPopularLocationsData: (
    query = {},
    headers = {},
    hasErrorHandler = false,
  ) =>
    request({
      method: HTTP_METHODS.GET,
      url: `${API_URLS.ferry.popular.getPopularLocations}?${jsonToQuery(query)}`,
      headers,
      hasErrorHandler,
    }),
  getPopularIslandsData: (query = {}, headers = {}, hasErrorHandler = false) =>
    request({
      method: HTTP_METHODS.GET,
      url: `${API_URLS.ferry.popular.getPopularIslands}?${jsonToQuery(query)}`,
      headers,
      hasErrorHandler,
    }),

  getPopularFerryCompaniesForLocation: (
    query = {},
    headers = {},
    hasErrorHandler = false,
  ) =>
    request({
      method: HTTP_METHODS.GET,
      url: `${API_URLS.ferry.popular.getPopularFerryCompaniesForLocation}?${jsonToQuery(query)}`,
      headers,
      hasErrorHandler,
    }),
};
